import { useState, useEffect } from 'react';
import { BreathworkNameDisplay } from '@breath-lab/types';
import { getServices } from '@breath-lab/services';
import { useAuth } from '@breath-lab/state';

export function useBreathworkNameDisplay(): BreathworkNameDisplay {
  const { user } = useAuth();
  const [fallback, setFallback] = useState<BreathworkNameDisplay>(() =>
    getServices().remoteConfig.getDefaultBreathworkNameDisplay(),
  );

  useEffect(() => {
    const rc = getServices().remoteConfig;
    rc.fetchAndActivate()
      .then(() => setFallback(rc.getDefaultBreathworkNameDisplay()))
      .catch(() => {});
  }, []);

  return user?.settings?.breathworkNameDisplay ?? fallback;
}
